export default "__VITE_ASSET__BObYTYeN__"